module.exports = __webpack_public_path__ + "static/media/Tejaswi_Kota_Resume.29d678d9.pdf";